<template>
  <section class="obra-visual-hero" aria-labelledby="obra-title">
    <div class="obra-visual-hero__banner" :style="bannerStyle">
      <div class="obra-visual-hero__overlay"></div>
      <div class="obra-visual-hero__top">
        <span class="obra-tag-age-rating" :style="ageRatingStyle">{{ ageRatingLabel }}</span>
        <ObraActionBar
          :is-favorite="Boolean(project.is_favorite)"
          :is-following-project="Boolean(project.is_follow)"
          :is-following-author="Boolean(author && author.is_follow)"
          :is-admin="isAdmin"
          @favorite-project="$emit('favorite-project')"
          @follow-project="$emit('follow-project')"
          @follow-author="$emit('follow-author')"
          @delete-project="$emit('delete-project')"
        />
      </div>
    </div>

    <div class="obra-visual-hero__body">
      <div class="obra-visual-hero__cover-wrap">
        <img v-if="coverImage" class="obra-visual-hero__cover" :src="coverImage" :alt="coverAlt" @contextmenu.prevent />
        <div v-else class="obra-visual-hero__cover obra-visual-hero__cover--empty" aria-hidden="true">
          <v-icon color="#d9d9d9" size="48">mdi-book-open-page-variant</v-icon>
        </div>
      </div>

      <div class="obra-visual-hero__content">
        <h1 id="obra-title" class="obra-visual-hero__title">{{ project.name }}</h1>
        <div v-if="visibleTags.length" class="obra-visual-hero__tags" aria-label="Categorias da obra">
          <span v-for="tag in visibleTags" :key="tag" class="obra-visual-hero__tag">{{ tag }}</span>
        </div>
        <div class="obra-visual-hero__cta-row">
          <v-btn class="obra-visual-hero__read zinnes-primary-btn" dark rounded large :disabled="!canStartReading" @click="$emit('start-reading')">
            Iniciar leitura
          </v-btn>
          <ObraAdminControls
            :is-admin="isAdmin"
            :age-rating-ids="ageRatingIds"
            :age-ratings="ageRatings"
            @age-rating-picked="$emit('age-rating-picked', $event)"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ObraActionBar from './ObraActionBar.vue';
import ObraAdminControls from './ObraAdminControls.vue';

export default {
  name: 'ObraVisualHero',
  components: { ObraActionBar, ObraAdminControls },
  props: {
    project: { type: Object, required: true },
    author: { type: Object, default: () => ({}) },
    tags: { type: Array, default: () => [] },
    canStartReading: { type: Boolean, default: false },
    ageRatingColor: { type: Function, required: true },
    isAdmin: { type: Boolean, default: false },
    ageRatingIds: { type: Array, default: () => [] },
    ageRatings: { type: Array, default: () => [] },
  },
  computed: {
    coverImage() {
      return this.project.project_thumb || '';
    },
    bannerImage() {
      return this.project.project_banner || '';
    },
    bannerStyle() {
      return this.bannerImage ? { backgroundImage: `url("${this.bannerImage}")` } : {};
    },
    coverAlt() {
      return `Capa da obra ${this.project.name || ''}`;
    },
    visibleTags() {
      return this.tags.filter(Boolean);
    },
    ageRating() {
      return this.project.age_rating || null;
    },
    ageRatingLabel() {
      return this.ageRating?.rating || 'Livre';
    },
    ageRatingStyle() {
      const age = this.ageRating?.age || 10;
      return { backgroundColor: this.ageRatingColor(age), color: age === 12 ? '#000' : '#fff' };
    },
  },
};
</script>
